import { gettext } from '@adjust/dashboard-core/lib/utils/localization';

export const allKpis = {
  overview: [
    gettext('impressions'), // number
    gettext('ctr'), // percent
    gettext('clicks'), // number
    gettext('installs'), // number
    gettext('uninstalls'), // number
    gettext('reinstalls'), // number
    gettext('reattribution_reinstalls'), // number
    gettext('uninstall_cohort'), // number
    gettext('limit_ad_tracking_installs'), // number
    gettext('limit_ad_tracking_install_rate'), // percent
    gettext('impression_conversion_rate'), // percent
    gettext('click_conversion_rate'), // percent
    gettext('deattributions'), // number
    gettext('reattributions'), // number
    gettext('sessions'), // number
    gettext('revenue_events'), // number
    gettext('cohort_revenue'), // currency
    gettext('cohort_ad_revenue'), // currency
    gettext('cohort_all_revenue'), // currency
    gettext('all_revenue'), // currency
    gettext('roas'), // percent
    gettext('revenue'), // currency
    gettext('daus'), // number
    gettext('waus'), // number
    gettext('maus'), // number
    gettext('gdpr_forgets'), // number
    gettext('ad_revenue'), // currency
    gettext('ad_impressions'), // number
    gettext('ad_rpm'), // currency
  ],
  cost: [
    gettext('paid_impressions'), // number
    gettext('ecpm'), // currency
    gettext('paid_clicks'), // number
    gettext('ecpc'), // currency
    gettext('paid_installs'), // number
    gettext('ecpi'), // currency
    gettext('cost'), // currency
    gettext('cohort_revenue'), // currency
    gettext('cohort_gross_profit'), // currency
    gettext('return_on_investment'), // percent
    gettext('rcr'), // percent
  ],
  'fraud-prevention': [
    gettext('impressions'), // number
    gettext('clicks'), // number
    gettext('installs'), // number
    gettext('sessions'), // number
    gettext('impression_conversion_rate'), // percent
    gettext('click_conversion_rate'), // percent
    gettext('rejected_installs'), // number
    gettext('rejected_install_rate'), // percent
    gettext('rejected_installs_anon_ip'), // number
    gettext('rejected_installs_too_many_engagements'), // number
    gettext('rejected_installs_distribution_outlier'), // number
    gettext('rejected_installs_click_injection'), // number
    gettext('rejected_installs_invalid_signature'), // number
    gettext('reattributions'), // number
    gettext('rejected_reattributions'), // number
    gettext('rejected_reattribution_rate'), // percent
    gettext('rejected_reattributions_anon_ip'), // number
    gettext('rejected_reattributions_too_many_engagements'), // number
    gettext('rejected_reattributions_distribution_outlier'), // number
    gettext('rejected_reattributions_click_injection'), // number
    gettext('daus'), // number
    gettext('waus'), // number
    gettext('maus'), // number
  ],
};

export const deattributionKpis = ['deattributions'];

export const conversionRateKpis = ['click_conversion_rate', 'impression_conversion_rate'];

export const clickAttributionTypeKpis = ['clicks', 'click_conversion_rate'];

export const impressionAttributionTypeKpis = ['impression_conversion_rate'];

export const adRevAndRevDataKpis = ['cohort_all_revenue', 'all_revenue'];

export const clickInjectionKpis = ['rejected_installs_click_injection', 'rejected_reattributions_click_injection'];

export const uninstallKpis = ['uninstalls', 'reinstalls', 'reattribution_reinstalls', 'uninstall_cohort'];

export const revenueKpis = [
  'revenue',
  'cohort_revenue',
  'return_on_investment',
  'cohort_gross_profit',
  'revenue_events',
  'revenue_per_revenue_event',
  'rcr',
];

export const allRevenueKpis = [
  'all_revenue',
  'all_revenue_total',
  'all_revenue_per_user',
  'all_revenue_total_in_cohort',
  'cohort_all_revenue',
];

export const adRevenueKpis = ['ad_revenue', 'ad_impressions', 'ad_rpm', 'cohort_ad_revenue', 'roas'];
